import { atomWithReset } from 'jotai/utils';

import { ModificationMode, UserActionMenuType, HandleModificationProps } from 'src/types/report';

export enum EditType {
  COMMENT = 'COMMENT',
  REPLY = 'REPLY',
}

export const commentModificationAtom = atomWithReset<
  | (HandleModificationProps<
      UserActionMenuType.COMMENT | UserActionMenuType.INSTANT_LEARNING_COMMENT
    > & {
      mode: ModificationMode;
      editType?: EditType;
    })
  | null
>(null);
